import {z} from 'zod';

export const LeasingMonthlyServiceKindSchema = z.enum([
  'MAINTENANCE',
  'WEAR',
  'MAINTENANCE_AND_WEAR',
  'VEHICLE_TAX',
  'LIABILITY_INSURANCE',
  'COMPREHENSIVE_INSURANCE',
  'TIRES',
  'INSPECTION',
  'RETURN_VALUE_INSURANCE',
]);
export type LeasingMonthlyServiceKind = z.infer<typeof LeasingMonthlyServiceKindSchema>;
